// Direct host first, legacy ENV pattern only when the direct value is empty.
// Mirrors registration_url_for_institution (SRM_BASE_URL, else SERVER_ENV).

export function trimValue(value) {
  return (value || '').trim();
}

export function resolveGpsDomain(env, rawDomain) {
  const raw = trimValue(rawDomain || 'goeducate.com')
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '');
  if (raw !== 'goeducate.com' && raw.endsWith('.goeducate.com')) {
    return raw;
  }
  const rootDomain = raw || 'goeducate.com';
  const name = trimValue(env);
  return name && name !== 'prod' ? `${name}.${rootDomain}` : rootDomain;
}

export function resolveGpsEvent(env, direct) {
  const value = trimValue(direct).replace(/\/+$/, '');
  if (value) {
    return value;
  }
  const name = trimValue(env);
  if (!name || name === 'prod') {
    return 'https://goeducate.com/events';
  }
  return `https://${name}.goeducate.com/events`;
}

export function resolveGpsUrl(env, direct) {
  const value = trimValue(direct);
  if (value) {
    return value.endsWith('/') ? value : `${value}/`;
  }
  const name = trimValue(env) || 'prod';
  return `https://pathways-${name}.goeducate.com/`;
}

const NOTIFICATIONS_HOST =
  'https://ivga9a4ks3.execute-api.us-east-1.amazonaws.com';
const STUDENT_PROFILE_HOST =
  'https://lj7gjv3fo2.execute-api.us-east-1.amazonaws.com';

export function resolveAwsStage(env, stage) {
  return trimValue(stage) || trimValue(env);
}

function withTrailingSlash(value) {
  return value.endsWith('/') ? value : `${value}/`;
}

export function resolveNotificationsSettings(env, direct, stage) {
  const value = trimValue(direct);
  if (value) {
    return withTrailingSlash(value);
  }
  return `${NOTIFICATIONS_HOST}/${resolveAwsStage(env, stage)}/`;
}

export function resolveStudentProfile(env, direct, stage, gpsEnv) {
  const value = trimValue(direct);
  if (value) {
    return withTrailingSlash(value);
  }
  const gps = trimValue(gpsEnv) || 'gps-ng';
  return `${STUDENT_PROFILE_HOST}/${resolveAwsStage(env, stage)}/${gps}/`;
}
